// src/AppRouter.jsx
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/auth/Login';
import Signup from './components/auth/Signup';
import ClerkLegacyVerifyRedirect from './components/auth/ClerkLegacyVerifyRedirect';
import Layout from './components/layouts/Layout';
import DOCGeneration from './components/pages/DOCGeneration';
import Dashboard from './components/pages/Dashboard';
import RAGSystem from './components/pages/RAGSystem';
import BRDGeneration from './components/pages/BRDGeneration';
import { ROUTES } from './constants/routes';
import PrivateRoute from './PrivateRoute';
import AuthFallback from './components/auth/AuthFallback';

function AppRouter() {
  return (
    <Routes>
        <Route path="/" element={<Navigate to={ROUTES.LOGIN} replace />} />
        {/* Legacy root Clerk paths (SignIn used to live at /) → /login/* so catch-all never remounts wrong flow */}
        <Route path="/verify-email-address/*" element={<ClerkLegacyVerifyRedirect />} />
        <Route path="/factor-one/*" element={<Navigate to={`${ROUTES.LOGIN}/factor-one`} replace />} />
        <Route path="/factor-two/*" element={<Navigate to={`${ROUTES.LOGIN}/factor-two`} replace />} />
        <Route path="/sso-callback/*" element={<Navigate to={`${ROUTES.LOGIN}/sso-callback`} replace />} />
        {/* Single splat per auth flow — Clerk steps must not switch Route elements (remounts SignIn/SignUp). */}
        <Route path={`${ROUTES.LOGIN}/*`} element={<Login />} />
        <Route path={`${ROUTES.SIGNUP}/*`} element={<Signup />} />
        {/* Old custom-auth URLs → Clerk sign-in (bookmarks/emails) */}
        <Route path={ROUTES.SET_PASSWORD} element={<Navigate to={ROUTES.LOGIN} replace />} />
        <Route path={ROUTES.FORGOT_PASSWORD} element={<Navigate to={ROUTES.LOGIN} replace />} />
        <Route path={ROUTES.RESET_PASSWORD} element={<Navigate to={ROUTES.LOGIN} replace />} />
        <Route path={ROUTES.CONFIRM_EMAIL} element={<Navigate to={ROUTES.LOGIN} replace />} />
        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
          <Route path={ROUTES.DOC_GENERATION} element={<DOCGeneration />} />
          <Route path={ROUTES.RAG_SYSTEM} element={<RAGSystem />} />
          <Route path={ROUTES.BRD} element={<BRDGeneration />} />
        </Route>
        <Route path="*" element={<AuthFallback />} />
    </Routes>
  );
}

export default AppRouter;
